import { StandardEvents } from '@shopify/events';
// Use the native cart update result, never an optimistic added-quantity total.
if (!window.lbcCartCountInstalled) {
  window.lbcCartCountInstalled = true;
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({cart}) => {
      if (!Number.isInteger(cart?.totalQuantity)) return;
      document.querySelectorAll('[data-lf-cart-count]').forEach((badge) => {
        badge.textContent = String(cart.totalQuantity);
        badge.hidden = cart.totalQuantity === 0;
      });
    }).catch(() => {});
  });
}

// Offer message (cart drawer / cart page), 2026-10-31: 1 item per order, free UK delivery on every order. No progress bar.
if (!window.lbcOfferBarInstalled) {
  window.lbcOfferBarInstalled = true;
  const lbcOfferMsg = (qty) => {
    if (qty > 1) return '1 item per order. Remove ' + (qty - 1) + (qty - 1 === 1 ? ' item' : ' items') + ' to check out.';
    return 'Free UK delivery on every order \u00b7 1 item per order';
  };
  const lbcOfferPaint = (cart) => {
    if (!cart || !Number.isInteger(cart.item_count)) return;
    const qty = cart.item_count, total = cart.total_price;
    // Limit-1 offer (2026-10-31): the cart section marks itself data-lbc-l1 when it holds a limit-1-per-order item.
    const l1 = !!document.querySelector('[data-lbc-offer][data-lbc-l1]') && qty > 0;
    document.querySelectorAll('[data-lbc-offer]').forEach((box) => {
      box.hidden = qty === 0;
      box.dataset.qty = String(qty);
      box.dataset.total = String(total);
      const msg = box.querySelector('[data-lbc-offer-msg]');
      if (msg) {
        msg.textContent = l1 ? (qty > 1 ? 'Limited offer: 1 item per order. Remove other items to check out.' : 'Limited offer: 1 item per order \u00b7 Free UK delivery on every order') : lbcOfferMsg(qty);
        msg.style.color = qty > 1 ? '#b72735' : '';
      }
    });
    // Checkout is a plain <a href="/checkout"> (2026-10-30). Only the >1 item cap disables it.
    document.querySelectorAll('[data-lbc-checkout]').forEach((btn) => {
      const off = qty > 1 || qty === 0;
      if (off && qty > 0) btn.dataset.lbcCapped = ''; else delete btn.dataset.lbcCapped;
      if (btn.tagName === 'A') {
        if (off) { btn.removeAttribute('href'); btn.setAttribute('aria-disabled', 'true'); }
        else { btn.setAttribute('href', '/checkout'); btn.removeAttribute('aria-disabled'); }
      } else btn.disabled = off;
    });
    document.querySelectorAll('[data-elva-delivery]').forEach((el) => {
      el.style.flexWrap = 'wrap';
      el.innerHTML = '<strong>UK delivery: FREE</strong><span class="elva-delivery-time" style="display:block;flex:0 0 100%;font-size:13px;font-weight:400;line-height:1.4;">Standard: 3\u20137 business days, plus 1\u20133 business days processing</span>';
    });
  };
  let lbcOfferTimer;
  const lbcOfferRefresh = () => {
    clearTimeout(lbcOfferTimer);
    lbcOfferTimer = setTimeout(() => {
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json()).then(lbcOfferPaint).catch(() => {});
    }, 150);
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    (event.promise || Promise.resolve()).then(lbcOfferRefresh, lbcOfferRefresh);
  });
  document.addEventListener('cart:update', lbcOfferRefresh);
}

// Cart cap (2026-10-31, was 5): 1 item per order. Guards theme cart requests client-side only.
// NOTE (re-check 2026-10-30): Yuko Order Limits is installed but has NO checkout validation/function active
// (Admin API validations: [], shopifyFunctions: []), so nothing enforces the cap at checkout.
if (!window.lbcCartCapInstalled) {
  window.lbcCartCapInstalled = true;
  const CAP = 1;
  const CAP_MSG = '1 item per order. Remove the item in your bag to add a different one.';
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  // Keep the note visible for 6s, re-applying it if the cart section is re-rendered meanwhile.
  let capUntil = 0, capTimer;
  const applyCapNote = () => {
    const on = Date.now() < capUntil;
    document.querySelectorAll('[data-lbc-cap-note]').forEach((n) => { n.hidden = !on; });
    if (!on) { clearInterval(capTimer); capTimer = null; }
  };
  const showCapNote = (msg) => {
    document.querySelectorAll('[data-lbc-cap-note]').forEach((n) => { n.textContent = msg || CAP_MSG; });
    capUntil = Date.now() + 6000;
    applyCapNote();
    if (!capTimer) capTimer = setInterval(applyCapNote, 250);
  };
  window.lbcShowCapNote = showCapNote;
  const toPairs = (body) => {
    if (body instanceof FormData || body instanceof URLSearchParams) return Array.from(body.entries());
    if (typeof body === 'string') {
      try { return { json: JSON.parse(body) }; } catch (e) { return Array.from(new URLSearchParams(body).entries()); }
    }
    return null;
  };
  // How many units an add request asks for (null = unknown, let it through).
  const addQty = (body) => {
    const d = toPairs(body);
    if (!d) return null;
    if (d.json) {
      const j = d.json;
      if (Array.isArray(j.items)) return j.items.reduce((a, it) => a + (parseInt(it.quantity, 10) || 1), 0);
      if (j.id) return parseInt(j.quantity, 10) || 1;
      return null;
    }
    const q = d.filter(([k]) => /^(quantity|items\[\d+\]\[quantity\])$/.test(k));
    if (q.length) return q.reduce((a, [, v]) => a + (parseInt(v, 10) || 0), 0);
    return d.some(([k]) => /^(id|items\[\d+\]\[id\])$/.test(k)) ? 1 : null;
  };
  // Cart total after a change/update request (null = unknown).
  const afterChange = (kind, body, cart) => {
    const d = toPairs(body);
    if (!d) return null;
    const items = cart.items || [];
    const match = (it, key) => String(it.key) === String(key) || String(it.variant_id) === String(key) || String(it.id) === String(key);
    if (kind === 'change') {
      const j = d.json || Object.fromEntries(d);
      const qty = parseInt(j.quantity, 10);
      if (!Number.isFinite(qty)) return null;
      let idx = -1;
      if (j.line) idx = parseInt(j.line, 10) - 1;
      else if (j.id != null) idx = items.findIndex((it) => match(it, j.id));
      if (idx < 0 || !items[idx]) return null;
      return cart.item_count - items[idx].quantity + qty;
    }
    let ups = d.json ? d.json.updates : null;
    if (!d.json) {
      const arr = d.filter(([k]) => k === 'updates[]').map(([, v]) => v);
      if (arr.length) ups = arr;
      else {
        const obj = {};
        d.forEach(([k, v]) => { const m = /^updates\[(.+)\]$/.exec(k); if (m) obj[m[1]] = v; });
        if (Object.keys(obj).length) ups = obj;
      }
    }
    if (!ups) return null;
    if (Array.isArray(ups)) return items.reduce((a, it, i) => a + (ups[i] != null ? parseInt(ups[i], 10) || 0 : it.quantity), 0);
    let total = 0;
    const used = new Set();
    items.forEach((it) => {
      const k = Object.keys(ups).find((key) => match(it, key));
      if (k != null) { used.add(k); total += parseInt(ups[k], 10) || 0; } else total += it.quantity;
    });
    Object.keys(ups).forEach((k) => { if (!used.has(k)) total += parseInt(ups[k], 10) || 0; });
    return total;
  };
  const blocked = (msg) => {
    msg = typeof msg === 'string' ? msg : CAP_MSG;
    showCapNote(msg);
    const payload = { status: 422, message: msg, description: msg, errors: msg };
    return new Response(JSON.stringify(payload), { status: 422, headers: { 'Content-Type': 'application/json' } });
  };
  // Limit-1 offer (2026-10-31): products tagged limit-1-per-order may only be bought alone, 1 unit per order.
  // Adding one replaces the cart; nothing can be added next to it; its quantity cannot go above 1.
  const L1_MSG = 'Limited offer: 1 item per order';
  const l1Cache = {};
  const isL1Handle = async (h) => {
    if (!h) return false;
    if (h in l1Cache) return l1Cache[h];
    let v = null;
    try { v = sessionStorage.getItem('lbcL1:' + h); } catch (e) {}
    if (v == null) {
      try {
        const p = await nativeFetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        v = (p.tags || []).map((t) => String(t).toLowerCase()).includes('limit-1-per-order') ? '1' : '0';
        try { sessionStorage.setItem('lbcL1:' + h, v); } catch (e) {}
      } catch (e) { v = '0'; }
    }
    return (l1Cache[h] = v === '1');
  };
  const cartHasL1 = async (cart) => (await Promise.all((cart.items || []).map((it) => isL1Handle(it.handle)))).some(Boolean);
  const l1Variants = () => {
    const set = new Set();
    document.querySelectorAll('[data-lbc-limit1-variants]').forEach((el) => el.dataset.lbcLimit1Variants.split(',').forEach((x) => x && set.add(x.trim())));
    return set;
  };
  const addIds = (body) => {
    const d = toPairs(body);
    if (!d) return [];
    if (d.json) return Array.isArray(d.json.items) ? d.json.items.map((it) => String(it.id)) : d.json.id != null ? [String(d.json.id)] : [];
    return d.filter(([k]) => /^(id|items\[\d+\]\[id\])$/.test(k)).map(([, v]) => String(v));
  };
  const forceQty1 = (body) => {
    if (body instanceof FormData || body instanceof URLSearchParams) { body.set('quantity', '1'); return body; }
    if (typeof body === 'string') {
      try { const j = JSON.parse(body); if (Array.isArray(j.items)) j.items.forEach((it) => { it.quantity = 1; }); else j.quantity = 1; return JSON.stringify(j); }
      catch (e) { const u = new URLSearchParams(body); u.set('quantity', '1'); return u.toString(); }
    }
    return body;
  };
  window.fetch = async function (input, init) {
    try {
      const url = new URL(typeof input === 'string' ? input : input?.url || String(input), location.href);
      const m = url.origin === location.origin && /\/cart\/(add|change|update)(\.js)?\/?$/.exec(url.pathname);
      const body = init?.body;
      if (m && body != null && (init.method || 'GET').toUpperCase() === 'POST') {
        const kind = m[1];
        const cart = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
        const lv = l1Variants();
        if (kind === 'add') {
          const ids = addIds(body);
          if (lv.size && ids.some((id) => lv.has(id))) {
            if (ids.length > 1) return blocked(L1_MSG);
            if (cart.item_count > 0) {
              await nativeFetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' });
            }
            init = { ...init, body: forceQty1(body) };
          } else if (cart.item_count > 0 && (await cartHasL1(cart))) {
            return blocked(L1_MSG + '. Remove the offer item to add other products.');
          } else {
            const q = addQty(body);
            if (q != null && cart.item_count + q > CAP) return blocked();
          }
        } else {
          const after = afterChange(kind, body, cart);
          if (after != null && after > 1 && after > cart.item_count && (await cartHasL1(cart))) return blocked(L1_MSG);
          if (after != null && after > CAP && after > cart.item_count) return blocked();
        }
      }
    } catch (e) { /* never break the native request on a guard error */ }
    // Checkout fix 2 2026-10-30: variant switches re-fetch the product page (?option_values=...). A transient 5xx
    // (seen: 502 on a jacket size click) left "Add to cart" disabled until reload. Retry same-origin GETs to
    // /products/ up to 2 times on 5xx / network error.
    let isVariantGet = false;
    try {
      const vu = new URL(typeof input === 'string' ? input : input?.url || String(input), location.href);
      isVariantGet = vu.origin === location.origin && /\/products\//.test(vu.pathname) &&
        (init?.method || (typeof input === 'object' && input?.method) || 'GET').toUpperCase() === 'GET';
    } catch (e) {}
    if (!isVariantGet) return nativeFetch(input, init);
    for (let attempt = 0; ; attempt++) {
      try {
        const res = await nativeFetch(input, init);
        if (res.status < 500 || attempt >= 2) return res;
      } catch (err) {
        if (err?.name === 'AbortError' || attempt >= 2) throw err;
      }
      if (init?.signal?.aborted) throw new DOMException('Aborted', 'AbortError');
      await new Promise((r) => setTimeout(r, attempt ? 1200 : 400));
    }
  };
  // Typed quantities above the cart cap: the theme clamps to the input max; tell the shopper why.
  const onTyped = (event) => {
    const el = event.target;
    if (!(el instanceof HTMLInputElement) || !el.matches('input[data-cart-line][data-lbc-cap-max]')) return;
    const max = parseInt(el.max, 10), v = parseInt(el.value, 10);
    if (Number.isFinite(max) && Number.isFinite(v) && v > max) showCapNote();
  };
  document.addEventListener('blur', onTyped, true);
  document.addEventListener('change', onTyped, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Enter') onTyped(e); }, true);
}

// Add-to-cart feedback (2026-10-30): after a successful add, make sure the shopper sees the cart.
// auto_open_cart_drawer is on in settings; this is a fallback for when the drawer is missing or fails to open.
if (!window.lbcAtcFeedbackInstalled) {
  window.lbcAtcFeedbackInstalled = true;
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event.action !== 'add') return;
    (event.promise || Promise.resolve()).then((res) => {
      if (res?.detail?.didError) return;
      setTimeout(() => {
        const dlg = document.querySelector('#cart-drawer dialog');
        if (dlg?.open || document.querySelector('dialog:modal')) return;
        const drawer = document.getElementById('cart-drawer');
        try { drawer?.open?.(); } catch (e) {}
        setTimeout(() => {
          if (!document.querySelector('#cart-drawer dialog')?.open && !/\/cart\/?$/.test(location.pathname)) {
            location.href = (window.Shopify?.routes?.root || '/') + 'cart';
          }
        }, 400);
      }, 1200);
    }).catch(() => {});
  });
}
